import api from './api';

// ==================== ADHERENTS PRINCIPAUX ====================

export const getPrincipaux = async (params = {}) => {
  const response = await api.get('/essie/principaux', { params });
  return response.data;
};

export const getPrincipal = async (id) => {
  const response = await api.get(`/essie/principaux/${id}`);
  return response.data;
};

export const createPrincipal = async (data) => {
  const response = await api.post('/essie/principaux', data);
  return response.data;
};

export const updatePrincipal = async (id, data) => {
  const response = await api.put(`/essie/principaux/${id}`, data);
  return response.data;
};

export const deletePrincipal = async (id) => {
  const response = await api.delete(`/essie/principaux/${id}`);
  return response.data;
};

export const getPrincipalSecondaires = async (id) => {
  const response = await api.get(`/essie/principaux/${id}/secondaires`);
  return response.data;
};

export const getPrincipauxStats = async (year = null) => {
  const params = year ? { year } : {};
  const response = await api.get('/essie/principaux/stats', { params });
  return response.data;
};

// ==================== ADHERENTS SECONDAIRES ====================

export const getSecondaires = async (params = {}) => {
  const response = await api.get('/essie/secondaires', { params });
  return response.data;
};

export const getSecondaire = async (id) => {
  const response = await api.get(`/essie/secondaires/${id}`);
  return response.data;
};

export const createSecondaire = async (data) => {
  const response = await api.post('/essie/secondaires', data);
  return response.data;
};

export const updateSecondaire = async (id, data) => {
  const response = await api.put(`/essie/secondaires/${id}`, data);
  return response.data;
};

export const deleteSecondaire = async (id) => {
  const response = await api.delete(`/essie/secondaires/${id}`);
  return response.data;
};

// ==================== DECES ====================

export const getDeces = async (params = {}) => {
  const response = await api.get('/essie/deces', { params });
  return response.data;
};

export const getDecesById = async (id) => {
  const response = await api.get(`/essie/deces/${id}`);
  return response.data;
};

export const createDeces = async (data) => {
  const response = await api.post('/essie/deces', data);
  return response.data;
};

export const updateDeces = async (id, data) => {
  const response = await api.put(`/essie/deces/${id}`, data);
  return response.data;
};

export const deleteDeces = async (id) => {
  const response = await api.delete(`/essie/deces/${id}`);
  return response.data;
};

export const getDecesStats = async (year = null) => {
  const params = year ? { year } : {};
  const response = await api.get('/essie/deces/stats', { params });
  return response.data;
};

export const getDecesPaymentStatus = async (id) => {
  const response = await api.get(`/essie/deces/${id}/status`);
  return response.data;
};

export const getAdherentsPaymentDetails = async () => {
  const response = await api.get('/essie/adherents/payment-details');
  return response.data;
};

export const sendDecesNotificationSMS = async (id) => {
  const response = await api.post(`/essie/deces/${id}/send-sms`);
  return response.data;
};

// ==================== COTISATIONS ====================

export const getCotisations = async (params = {}) => {
  const response = await api.get('/essie/cotisations', { params });
  return response.data;
};

export const getCotisation = async (id) => {
  const response = await api.get(`/essie/cotisations/${id}`);
  return response.data;
};

export const createCotisation = async (data) => {
  const response = await api.post('/essie/cotisations', data);
  return response.data;
};

export const updateCotisation = async (id, data) => {
  const response = await api.put(`/essie/cotisations/${id}`, data);
  return response.data;
};

export const deleteCotisation = async (id) => {
  const response = await api.delete(`/essie/cotisations/${id}`);
  return response.data;
};

export const getCotisationsStats = async () => {
  const response = await api.get('/essie/cotisations/stats');
  return response.data;
};

// ==================== SMS ====================

export const sendBroadcastSMS = async (message) => {
  const response = await api.post('/essie/sms/broadcast', { message });
  return response.data;
};
